import { isWechat } from './util'

var wxApi = {
  CONSTANTS: {
    wxApiSignUrl_auto:
      '//mrobot.pcauto.com.cn/v3/weixin/getSign?account=chinacar666&callback=wxApi.wxConfig&url=' +
      encodeURIComponent(window.location.href.split('#')[0]),
    wxApiSignUrl_pangku:
      '//merchant.pangku.com/pcauto/jssdk?current_url=' + encodeURIComponent(window.location.href.split('#')[0]),
    wxApiJSUrl: '//res.wx.qq.com/open/js/jweixin-1.4.0.js'
  },
  getScript: function(option) {
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = option.url
    script.charset = option.charset || 'UTF-8'
    script.onload = script.onreadystatechange = function() {
      if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
        this.onload = this.onreadystatechange = null
        option.callback && option.callback()
      }
    }
    document.getElementsByTagName('head')[0].appendChild(script)
  },
  wxConfig: function(data) {
    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: [
        'checkJsApi',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'hideMenuItems',
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'showAllNonBaseMenuItem',
        'translateVoice',
        'startRecord',
        'stopRecord',
        'onRecordEnd',
        'playVoice',
        'pauseVoice',
        'stopVoice',
        'uploadVoice',
        'downloadVoice',
        'chooseImage',
        'previewImage',
        'uploadImage',
        'downloadImage',
        'getNetworkType',
        'openLocation',
        'getLocation',
        'hideOptionMenu',
        'showOptionMenu',
        'closeWindow',
        'scanQRCode',
        'chooseWXPay',
        'openProductSpecificView',
        'addCard',
        'chooseCard',
        'openCard'
      ]
    })
  },
  init: function(fn) {
    if (navigator.userAgent.toLowerCase().match(/micromessenger/i) != 'micromessenger') return
    var wxApiSignUrl = ''
    var hostname = window.location.hostname
      .split('.')
      .splice(1)
      .join('.')
    switch (hostname) {
      case 'pcauto.com.cn':
        wxApiSignUrl = this.CONSTANTS.wxApiSignUrl_auto
        break
      case 'pangku.com':
      case 'pangku01.com':
        wxApiSignUrl = this.CONSTANTS.wxApiSignUrl_pangku
        break
      default:
        return false
    }
    
    var _this = this
    _this.getScript({
      url: this.CONSTANTS.wxApiJSUrl,
      callback: function() {
        _this.getScript({
          url: wxApiSignUrl,
          callback: function() {
            wx.ready(function() {
              fn && fn()
            })
            wx.error(function(res) {
              console.log(res)
            })
          }
        })
      }
    })
  }
}

class Share {
  constructor(shareData) {
    this.init(shareData)
  }
  init(shareData) {
    shareData.link = `${shareData.link}${window.location.search}`
    shareData.link = shareData.link.replace('cat.pangku.com', window.location.host)
    shareData.link = shareData.link.replace('cat2.pangku.com', window.location.host)
    shareData.link = shareData.link.replace('cat.pangku01.com', window.location.host)
    if (isWechat) {
      window.wxApi = wxApi
      wxApi.init(() => {
        wx.onMenuShareAppMessage(shareData) // 分享给朋友
        wx.onMenuShareTimeline(shareData) // 分享到朋友圈
        wx.onMenuShareQQ(shareData) // 分享到QQ
        wx.onMenuShareWeibo(shareData) // 分享到微博
      })
    } else {
      for (let key in shareData) {
        const metaEle = document.createElement('meta')
        metaEle.name = `Alipay:${key}`
        metaEle.content = `${shareData[key]}`
        document.head.appendChild(metaEle)
      }
    }
  }
}

export default Share
